import { render } from "./AddVehicle.vue?vue&type=template&id=b53d8654"
import script from "./AddVehicle.vue?vue&type=script&lang=js"
export * from "./AddVehicle.vue?vue&type=script&lang=js"
script.render = render

export default script